<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>プロジェクト実績</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 整体 -->
      <section>
        <div class="container gradient-background">
          <!-- 标签 -->
          <div class="game-menu">
            <div class="menu-item">
              <span class="text" @click="forId('bzdy')"
                ><span class="arrow">▶</span> 半導体 | 資通 |
                電子業界の工場建設</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('qccy')"
                ><span class="arrow">▶</span> 自動車産業関連</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('hzjy')"
                ><span class="arrow">▶</span> 航空 | 船舶 | 機械</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('nysh')"
                ><span class="arrow">▶</span> エネルギー・石油化学産業</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('zzwl')"
                ><span class="arrow">▶</span> 製造業生産 | 物流・倉庫管理</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('ktlw')"
                ><span class="arrow">▶</span> 鉱業 | 鉄鋼 | アルミニウム |
                五金製造</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('sffy')"
                ><span class="arrow">▶</span> 食品 | 繊維 | 服飾</span
              >
            </div>
            <div class="menu-item">
              <span class="text" @click="forId('bsgy')"
                ><span class="arrow">▶</span> 百貨店・小売 | 商業施設 |
                高層ビル</span
              >
            </div>
          </div>

          <!-- 标签1 -->
          <section id="bzdy">
            <div>
              <h2>
                <span class="hspan">半導体 | 資通 | 電子業界の工場建設</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in bzdyList"
                :key="index"
                @click="openModal(index, 'bzdyList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <p>{{ item.jp_title }}</p>
                  <!--<p>{{ item.showZTitle }}</p>-->
                </div>
              </div>
            </div>
            <div v-if="bzdyModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('bzdyList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.bzdySelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in bzdyList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="qccy">
            <div>
              <h2>
                <span class="hspan2">自動車産業関連</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in qccyList"
                :key="index"
                @click="openModal(index, 'qccyList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="qccyModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('qccyList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.qccySelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in qccyList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="hzjy">
            <div>
              <h2>
                <span class="hspan3">航空 | 船舶 | 機械</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in hzjyList"
                :key="index"
                @click="openModal(index, 'hzjyList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="hzjyModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('hzjyList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.hzjySelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in hzjyList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="nysh">
            <div>
              <h2>
                <span class="hspan4">エネルギー・石油化学産業</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in nyshList"
                :key="index"
                @click="openModal(index, 'nyshList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="nyshModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('nyshList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.nyshSelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in nyshList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="zzwl">
            <div>
              <h2>
                <span class="hspan5">製造業生産 | 物流・倉庫管理</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in zzwlList"
                :key="index"
                @click="openModal(index, 'zzwlList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="zzwlModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('zzwlList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.zzwlSelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in zzwlList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="ktlw">
            <div>
              <h2>
                <span class="hspan6"
                  >鉱業 | 鉄鋼 | アルミニウム | 五金製造</span
                >
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in ktlwList"
                :key="index"
                @click="openModal(index, 'ktlwList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="ktlwModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('ktlwList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.ktlwSelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in ktlwList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="sffy">
            <div>
              <h2>
                <span class="hspan7">食品 | 繊維 | 服飾</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in sffyList"
                :key="index"
                @click="openModal(index, 'sffyList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="sffyModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('sffyList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.sffySelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in sffyList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
          <section id="bsgy">
            <div>
              <h2>
                <span class="hspan8">百貨店・小売 | 商業施設 | 高層ビル</span>
              </h2>
            </div>
            <div class="container-fluid">
              <div
                class="col-lg-3 col-xs-6"
                v-for="(item, index) in bsgyList"
                :key="index"
                @click="openModal(index, 'bsgyList')"
              >
                <div class="gcjsImg">
                  <img
                    v-lazy="item.showImage1"
                    alt=""
                    style="width: 100%; height: 100%"
                    :key="index"
                  />
                </div>
                <div class="gcjsp" style="white-space: pre-line">
                  <!-- <p>{{ item.showZTitle }}</p> -->
                  <p>{{ item.jp_title }}</p>
                </div>
              </div>
            </div>
            <div v-if="bsgyModelOpen" class="modal">
              <div class="modal-content">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal('bsgyList')"
                  >&times;</span
                >
                <!-- 详细内容 -->
                <div class="xxd">
                  <el-carousel
                    :autoplay="false"
                    trigger="click"
                    indicator-position="outside"
                    :initial-index="this.bsgySelectedIndex"
                  >
                    <el-carousel-item
                      v-for="(item, index) in bsgyList"
                      :key="index"
                    >
                      <div class="col-lg-12 col-xs-12 xxnrbor">
                        <div class="content">
                          <div class="text-container">
                            <div class="col-lg-12 col-xs-12">
                              <img
                                :src="item.showImage1"
                                alt="Lazy-loaded Image"
                                class="showImg"
                              />
                            </div>
                            <div
                              class="col-lg-12 col-xs-12"
                              v-if="item.showImage2 != null"
                            >
                              <div class="xxnrsen">
                                <div class="row">
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage2 != null"
                                    @click="changeImages(item, 2)"
                                  >
                                    <img
                                      :src="item.showImage2"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage3 != null"
                                    @click="changeImages(item, 3)"
                                  >
                                    <img
                                      :src="item.showImage3"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                  <div
                                    class="col-lg-4 col-xs-4"
                                    v-if="item.showImage4 != null"
                                    @click="changeImages(item, 4)"
                                  >
                                    <img
                                      :src="item.showImage4"
                                      alt="Lazy-loaded Image"
                                      class="showImgTitle"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="textCon col-lg-12 col-xs-12">
                              <p class="topTitle1">{{ item.jp_title }}</p>

                              <p class="topTitle2">
                                場所: {{ item.jp_location }}
                              </p>
                              <div v-if="item.jp_structure != null">
                                <p class="centerTitle1">
                                  {{ item.jp_structure }}
                                </p>
                                <p class="centerTitle1">{{ item.jp_system }}</p>
                              </div>
                              <div v-else>
                                <div
                                  v-for="(item, index) in item.descriptions"
                                  :key="index"
                                >
                                  <p class="centerTitle2">
                                    {{ item.jp_content }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </section>
    <!-- 邮箱 -->
    <div class="mailbg">
      <to-mail button-text="お問い合わせ"></to-mail>
    </div>
  </div>
</template>

<script>
import { data } from 'jquery'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      bzdyModelOpen: false, // 控制模态框的显示状态
      bzdySelectedIndex: 0,
      qccyModelOpen: false, // 控制模态框的显示状态
      qccySelectedIndex: 0,
      hzjyModelOpen: false, // 控制模态框的显示状态
      hzjySelectedIndex: 0,
      nyshModelOpen: false, // 控制模态框的显示状态
      nyshSelectedIndex: 0,
      zzwlModelOpen: false, // 控制模态框的显示状态
      zzwlSelectedIndex: 0,
      ktlwModelOpen: false, // 控制模态框的显示状态
      ktlwSelectedIndex: 0,
      sffyModelOpen: false, // 控制模态框的显示状态
      sffySelectedIndex: 0,
      bsgyModelOpen: false, // 控制模态框的显示状态
      bsgySelectedIndex: 0,
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },
    // 打开模态框
    openModal(index, List) {
      console.log(data)

      if (List == 'bzdyList') {
        this.bzdySelectedIndex = index
        this.bzdyModelOpen = true
      } else if (List == 'qccyList') {
        this.qccySelectedIndex = index
        this.qccyModelOpen = true
      } else if (List == 'hzjyList') {
        this.hzjySelectedIndex = index
        this.hzjyModelOpen = true
      } else if (List == 'nyshList') {
        this.nyshSelectedIndex = index
        this.nyshModelOpen = true
      } else if (List == 'zzwlList') {
        this.zzwlSelectedIndex = index
        this.zzwlModelOpen = true
      } else if (List == 'ktlwList') {
        this.ktlwSelectedIndex = index
        this.ktlwModelOpen = true
      } else if (List == 'sffyList') {
        this.sffySelectedIndex = index
        this.sffyModelOpen = true
      } else if (List == 'bsgyList') {
        this.bsgySelectedIndex = index
        this.bsgyModelOpen = true
      }
    },
    // 关闭模态框
    closeModal(List) {
      if (List == 'bzdyList') {
        this.bzdyModelOpen = false
      } else if (List == 'qccyList') {
        this.qccyModelOpen = false
      } else if (List == 'hzjyList') {
        this.hzjyModelOpen = false
      } else if (List == 'nyshList') {
        this.nyshModelOpen = false
      } else if (List == 'zzwlList') {
        this.zzwlModelOpen = false
      } else if (List == 'ktlwList') {
        this.ktlwModelOpen = false
      } else if (List == 'sffyList') {
        this.sffyModelOpen = false
      } else if (List == 'bsgyList') {
        this.bsgyModelOpen = false
      }
    },
    //更换图片
    changeImages(item, num) {
      const targetKey = `showImage${num}`
      // 使用Vue.set 确保响应式更新
      const temp = item.showImage1 // 保存原始st1值
      this.$set(item, 'showImage1', item[targetKey]) // st1 = 目标值
      this.$set(item, targetKey, temp)
    },
  },
  mounted() {
    this.$store.dispatch('bzdyList')
    this.$store.dispatch('qccyList')
    this.$store.dispatch('hzjyList')
    this.$store.dispatch('nyshList')
    this.$store.dispatch('zzwlList')
    this.$store.dispatch('ktlwList')
    this.$store.dispatch('sffyList')
    this.$store.dispatch('bsgyList')
  },
  computed: {
    ...mapState({
      bzdyList: (state) => state.gcyj.bzdyList,
      qccyList: (state) => state.gcyj.qccyList,
      hzjyList: (state) => state.gcyj.hzjyList,
      nyshList: (state) => state.gcyj.nyshList,
      zzwlList: (state) => state.gcyj.zzwlList,
      ktlwList: (state) => state.gcyj.ktlwList,
      sffyList: (state) => state.gcyj.sffyList,
      bsgyList: (state) => state.gcyj.bsgyList,
    }),
  },
}
</script>

<style scoped>
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/gcyj/1.png) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 80vw;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}

.hspan,
.hspan2,
.hspan3,
.hspan4,
.hspan5,
.hspan6,
.hspan7,
.hspan8,
.hspan9 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.container-fluid {
  margin: 60px auto;
}

.showImg {
  width: 65vw;
  height: 45vh;
}
.showImgTitle {
  width: 100%;
  height: 15vh;
}

.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

/* 模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  background-color: #58585a;
  padding: 70px 0;
  border-radius: 8px;
  max-width: 100vw;
  height: 100vh;
  text-align: center;
}

/* 关闭按钮 */
.xclose {
  position: absolute;
  top: 20px;
  right: 15px;
  font-size: 26px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  opacity: 1;
}

.xxd {
  width: 100vw;
  height: auto;
  max-height: 90%;
}

.xxp {
  padding: 5px;
}

.xxnrbor {
  padding: 0 100px;
  height: 90vh;
}

div /deep/ .el-carousel__container {
  height: 92vh;
}

div /deep/ .el-carousel__arrow {
  height: 50px;
  width: 50px;
  font-size: 33px;
}

div /deep/ .el-carousel__arrow--right {
  right: 34px;
}

/* 系统 */
.content {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 90vw;
  display: flex;
}

.content .text-container {
  width: 70vw;
  height: auto;
  margin: 0 auto;
}

.textCon {
  margin-left: 20px;
  margin-top: 20px;
}

.content .text-container h3 {
  padding: 10px;
  margin: 0;
  font-size: 24px;
  color: #fff;
  text-align: left;
}
.content .text-container p {
  padding: 2px;
  line-height: 1.2;
  text-align: left;
  color: #fff;
}
.content .img-container img {
  border: 3px solid #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}

/* 指示灯 */
div /deep/.el-carousel__indicators--horizontal {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translate(-50%, 0);
  text-align: center;
  width: 90vw;
  padding: 5px;
}
div /deep/.el-carousel__indicator--horizontal button {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  opacity: 0.5;
}
div /deep/.el-carousel__indicator--horizontal.is-active button {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #fff;
  opacity: 1;
}
.spaceCon {
  margin: 60px auto 0;
}

.gcjsImg {
  position: relative; /* 父容器設為相對定位 */
  width: 100%;
  height: 15vw; /* 按需設置高度 */
  margin: 0;
  text-align: center;
  background-color: #fff;
}
.gcjsp {
  margin: 20px 0;
  height: 60px;
}
.gcjsp p {
  width: auto;
  text-align: center;
  font-size: 22px;
}

/* 箭头 */
.game-menu {
  margin: 100px auto;
  padding: 30px;
  border-radius: 10px;
}

.menu-item {
  padding: 5px 25px;
  color: #000;
  font-size: 28px;
  font-weight: bolder;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
}

/* 关键修改：箭头定位 */
.text {
  position: relative;
  display: inline-block;
  padding-left: 25px; /* 为箭头预留空间 */
}

.arrow {
  position: absolute;
  left: 0;
  opacity: 0;
  transform: translateX(-10px);
  transition: all 0.3s;
}

/* 悬停交互优化 */
.menu-item:hover {
  color: #8b0000;
}

.menu-item:hover .arrow {
  opacity: 1;
  transform: translateX(0);
  animation: pulse 1s infinite;
}

.xxnrsen {
  width: 65vw;
  height: 15vh;
  margin: 20px auto 0;
}

.topTitle1 {
  white-space: pre-line;
  font-size: 18px;
  margin: 0 0 2px 0;
  font-weight: bold;
}
.topTitle2 {
  white-space: pre-line;
  font-size: 18px;
  margin: 0 0 15px 0;
  font-weight: bold;
}
.centerTitle1 {
  white-space: pre-line;
  font-size: 16px;
  margin: 0 0 5px 0;
}
.centerTitle2 {
  white-space: pre-line;
  font-size: 16px;
  margin: 0 0 5px 0;
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .text {
    padding-left: 20px;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2,
  .hspan3,
  .hspan4,
  .hspan5,
  .hspan6,
  .hspan7,
  .hspan8,
  .hspan9 {
    font-size: 20px;
  }
  .gcjsImg {
    height: 25vw;
  }
  .container-fluid {
    margin: 30px auto;
  }
  .gcjsp {
    margin: 10px 0;
    height: 40px;
  }
  .gcjsp p {
    font-size: 18px;
  }
  .showImg {
    width: 90vw;
    height: 38vh;
  }
  .banner-info span {
    font-size: 30px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 0px;
    font-size: 14px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 20px;
    width: 30px;
    height: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%, 0);
    text-align: center;
    width: 90vw;
    padding: 4px;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    width: 100%;
  }
  .game-menu {
    margin: 50px auto;
    padding: 0;
  }
  .menu-item {
    font-size: 20px;
  }
  .xxnrbor {
    padding: 0 10px;
  }
  .col-xs-12 {
    padding: 0 10px;
  }
  .showImgTitle {
    width: 100%;
    height: 12vh;
  }
  .xxnrsen {
    width: 89vw;
    height: 12vh;
    margin: 10px auto 0;
  }
  .content {
    width: 100vw;
  }
  .modal-content {
    padding: 35px 0;
  }
  .textCon {
    margin-left: 25px;
  }
}
/* 响应式调整 */
@media (max-width: 768px) {
  .text {
    padding-left: 20px;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2,
  .hspan3,
  .hspan4,
  .hspan5,
  .hspan6,
  .hspan7,
  .hspan8,
  .hspan9 {
    font-size: 18px;
  }
  .gcjsImg {
    height: 25vw;
  }
  .container-fluid {
    margin: 30px auto;
  }
  .gcjsp {
    margin: 10px 0;
    height: 40px;
  }
  .gcjsp p {
    font-size: 13px;
  }
  .showImg {
    width: 90vw;
    height: 30vh;
  }
  .banner-info span {
    font-size: 27px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .xxd {
    margin: 0;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 0px;
    font-size: 13px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 20px;
    width: 30px;
    height: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 15px;
    transform: translate(-50%, 0);
    text-align: center;
    width: 100vw;
    padding: 3px;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    width: 100%;
  }
  .game-menu {
    margin: 50px auto;
    padding: 0;
  }
  .menu-item {
    font-size: 15px;
  }
  .xxnrbor {
    padding: 0 5px;
  }
  .col-xs-12 {
    padding: 0 5px;
  }
  .showImgTitle {
    width: 100%;
    height: 12vh;
  }
  .xxnrsen {
    width: 85vw;
    height: 12vh;
    margin: 10px auto 0;
  }
  .content {
    width: 100vw;
  }
  .modal-content {
    padding: 35px 0;
  }
  .textCon {
    margin-left: 5px;
  }
}
@media (min-width: 2000px) {
  .banner-info span {
    font-size: 65px;
  }
  .text {
    font-size: 35px;
  }
  .menu-item {
    padding: 10px 25px;
  }
  .hspan,
  .hspan2,
  .hspan3,
  .hspan4,
  .hspan5,
  .hspan6,
  .hspan7,
  .hspan8,
  .hspan9 {
    font-size: 34px;
  }
  .gcjsp p {
    font-size: 26px;
  }
  .gcjsp {
    height: 80px;
  }
  .textCon {
    font-size: 25px;
  }
}
</style>
